var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgApFireRiskAssessmentIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 36,
    height: 36,
    viewBox: "0 0 36 36",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "b"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 36,
    height: 36
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "a",
    clipPath: "url(#b)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(-1779.391 -8191)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(1782.391 8191)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M20.839,41a.412.412,0,0,1-.312-.142L11.51,31.91a.41.41,0,0,1-.145-.314V9.406a3.434,3.434,0,0,1,.84-2.274,2.772,2.772,0,0,1,2.078-.972h1.88V5.412A.412.412,0,0,1,16.579,5h20.48a.412.412,0,0,1,.412.412V6.16h1.88a2.772,2.772,0,0,1,2.08.972,3.434,3.434,0,0,1,.84,2.274V37.754a3.432,3.432,0,0,1-.84,2.274A2.771,2.771,0,0,1,39.354,41ZM22.97,28.54H37.139a.412.412,0,0,0,0-.825H22.97a.412.412,0,0,0,0,.825Zm0,1.54H37.139a.412.412,0,0,0,0-.824H22.97a.412.412,0,1,0,0,.824Zm-8.235,1.1v-5.1a.412.412,0,0,1,.412-.412h5.631a.412.412,0,0,1,.412.412v5.632a.412.412,0,0,1-.412.412h-.493l.012.012a3.236,3.236,0,0,1,.953,2.293v5.744h18.1a1.957,1.957,0,0,0,1.465-.692,2.609,2.609,0,0,0,.632-1.73V9.406a2.608,2.608,0,0,0-.632-1.729,1.957,1.957,0,0,0-1.465-.692h-1.88V8.313a.412.412,0,0,1-.412.412H16.579a.412.412,0,0,1-.412-.412V6.984h-1.88a1.956,1.956,0,0,0-1.462.692,2.608,2.608,0,0,0-.632,1.729V31.184Zm4.132.117h1.5V26.494H15.56v4.691H18A3.22,3.22,0,0,1,18.867,31.3Zm4.1-9.948H37.139a.412.412,0,0,0,0-.824H22.97a.412.412,0,1,0,0,.824Zm0,1.54H37.139a.412.412,0,0,0,0-.824H22.97a.412.412,0,1,0,0,.824Zm-7.823-4.411a.412.412,0,0,0-.412.412v5.632a.412.412,0,0,0,.412.412h5.631a.412.412,0,0,0,.412-.412V18.9a.412.412,0,0,0-.412-.412Zm5.22.825H15.56v4.808h4.808Zm2.6-5.14H37.139a.412.412,0,0,0,0-.824H22.97a.412.412,0,1,0,0,.824Zm0,1.54H37.139a.412.412,0,0,0,0-.824H22.97a.412.412,0,1,0,0,.824ZM15.148,11.3a.412.412,0,0,0-.412.412v5.632a.412.412,0,0,0,.412.412h5.631a.412.412,0,0,0,.412-.412V11.709a.412.412,0,0,0-.412-.412Zm5.22.823H15.56v4.809h4.808Zm16.28-6.3H16.99V7.9H36.648V5.824ZM20.426,39.6V34.431A2.43,2.43,0,0,0,18,32.009H12.776Z",
    transform: "translate(-11.365 -5)",
    stroke: "#000",
    strokeWidth: 0.1,
    fillRule: "evenodd"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(1787.103 8199.368)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M15.108,19.089l1.007,1.235a.381.381,0,0,0,.536.055l.019-.017h0l1.83-1.707a.382.382,0,1,0-.52-.559l-1.532,1.43-.75-.919a.382.382,0,0,0-.592.483Zm-.2-7.1,1.007,1.235a.381.381,0,0,0,.536.055l.019-.017h0l1.83-1.707a.382.382,0,1,0-.52-.557l-1.532,1.43-.748-.919a.382.382,0,0,0-.592.483Z",
    transform: "translate(-14.82 -10.878)",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.108,19.089l1.007,1.235a.381.381,0,0,0,.536.055l.019-.017h0l1.83-1.707a.382.382,0,1,0-.52-.559l-1.532,1.43-.75-.919a.382.382,0,0,0-.592.483Zm-.2-7.1,1.007,1.235a.381.381,0,0,0,.536.055l.019-.017h0l1.83-1.707a.382.382,0,1,0-.52-.557l-1.532,1.43-.748-.919a.382.382,0,0,0-.592.483Z",
    transform: "translate(-14.82 -10.878)",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-14.015,3.871l1.007,1.235a.381.381,0,0,0,.536.055l.019-.017h0l1.83-1.707A.382.382,0,0,0-10.5,3.07a.382.382,0,0,0-.263-.283.382.382,0,0,0-.375.092l-1.532,1.43-.75-.919a.382.382,0,0,0-.537-.055.382.382,0,0,0-.055.537Z",
    transform: "translate(14.205 11.592)",
    fillRule: "evenodd"
  })))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgApFireRiskAssessmentIcon);
export default __webpack_public_path__ + "static/media/ap-fire-risk-assessment-icon.589419b725e5e2cdcf2a591c2a207cbd.svg";
export { ForwardRef as ReactComponent };